import { store } from '../store'
import { ACL_OTHER, PERMISSIONS, TAbstractCatalogConfig } from '../models/AbstractCatalogConfig'
import { TAbstractCatalogItem } from '../models/AbstractCatalogItem'
import { TExtraFieldValue } from '../models/ExtraField'

export const hasAccess = (config: TAbstractCatalogConfig | undefined, permission: PERMISSIONS): boolean => {
  if (!config) {
    window.logger.error('config undefined')
    return false
  }
  if (!config.id || store.profile.isSuperUser) {
    return true
  }
  const userAcl = config.acl.find(i => store.profile.currentUserEmails.includes(i.profileID))
  const otherAcl = config.acl.find(i => i.profileID === ACL_OTHER)
  if (userAcl) {
    return userAcl.permissions.includes(permission) || userAcl.permissions.includes(PERMISSIONS.CREATOR)
  }
  if (otherAcl) {
    return otherAcl.permissions.includes(permission)
  }
  return true
}

export const createInitialConfigFormValues = (item: TAbstractCatalogConfig, isCreate: boolean) => ({
  ...item,
  acl: isCreate
    ? [
      { profileID: store.profile.currentUserEmail, permissions: [PERMISSIONS.CREATOR] },
      { profileID: ACL_OTHER, permissions: [
          PERMISSIONS.CATALOG_UPDATE,
          PERMISSIONS.CATALOG_DELETE,
          PERMISSIONS.ITEM_UPDATE,
          PERMISSIONS.ITEM_DELETE,
          PERMISSIONS.BINDING,
        ] },
    ]
    : item.acl,
})

export const formValuesToEntity = <C extends TAbstractCatalogConfig, I extends TAbstractCatalogItem>(config: C, item: I, values: TObjectAny): I => {
  const fields = config.fields.map((f, idx): TExtraFieldValue => ({
    fieldID: f.id,
    fieldName: f.name,
    value: values.fields?.[idx]?.value ?? '',
  }))
  return {
    ...item,
    catalogId: config.id,
    ...values,
    fields,
  }
}
